import React from "react";
import Header from "@appComponents/Header/Header";
import WhitePaper from "@appComponents/WhitePaper/WhitePaper";
import * as elements from "@appStyles/_elements.module.scss";
import ExpansionPanel from "@appComponents/ExpansionPanel/ExpansionPanel";
import { Link } from "react-router-dom";
import { FundsAppContext } from "@features/context";
import { classNames as cn } from "@features/utils/reactFunctions";
import { MAIN_CURRENCY } from "@bundles/consts";

const swiftDoc = `${process.env.S3_PUBLIC_DOCUMENTS_ROOT_URL}pdfs/deposits-swift.pdf`;
const depositImg = require("./images/deposit-img.jpg");
import * as style from "./DepositsLandingPageStyle.module.scss"

const questions = [
  {
    question: "What is USD*?",
    answer: [
      `All traditional currencies (Example USD, EUR, GBP, CNY, JPY and any other traditional currency) you send
      to Bnk To The Future are converted upon deposit into United States Dollars (USD) and held in a range of
      stablecoins that we call USD*. `,

      `These stablecoins are primarily held in TUSD (TrueUSD) and USDT (Tether), with some held in other
      stablecoins which may include but will not be limited to DAI, PAX, USDC, GUSD, BUSD amongst others.
      Therefore, your USD* balance on BF* is backed by a mix of US Dollar fiat funds, stablecoins backed by
      USD and some decentralised stablecoins. Hence any transaction on the BF Platform will occur in USD*
      unless you are investing, for example, in a Primary Offering through one of our Third Party Escrow
      Providers or you are paying in Credit or Debit Cards for an investment. `,

      `We have introduced USD* to make it easier for many of our investors to deposit and withdraw
          the type of USD/stablecoin they feel most comfortable with and is most convenient for them. `,
    ],
  },
  {
    question: "What is a USD stable coin?",
    answer: [
      `A USD stablecoin is a cryptocurrency that attempts to offer price stability with a pegged exchange rate
      (called a peg) to the US Dollar and is reported to be fully backed by USD dollars. Other stablecoins
      may use an algorithmic mechanism to try to maintain their peg to USD. Stablecoins attempt to offer
      the best of both worlds - instant processing-as easy as sending an email and remove volatility when
      investments are priced in dollars. `,

      `Please note that there is no guarantee the stablecoins will hold their peg to USD and therefore
      in an extreme event there may be currency and counterparty risks associated with each stablecoin.
      We diversify across a range of stablecoins in order to manage some of these risks, but investors
      should be aware of the currency and counterparty risks before depositing. `,
    ],
  },
  {
    question:
      "Which traditional currencies can I deposit and are there any fees to convert them?",
    answer: [
      `You are able to deposit any traditional currency supported by SWIFT. A full list can
      be found <a href=${swiftDoc} class=${style.link} target="_blank" rel="noopener noreferrer"> here</a>.
      Once received the bank will convert them to USD at the exchange rate at the point
      of receipt and will charge bank fees which will only be known to us after the conversion has
      taken place. Investors will have to assume all currency risk and all third party fees will be
      deducted from their deposit. Unfortunately, banks only reveal the exchange rate and fees after
      processing the conversion so the extent of the fees will be unknown until after they are converted.`,
    ],
  },
];

const DepositsLandingPage: React.FunctionComponent = (props) => {
  const { appLink } = React.useContext(FundsAppContext);
  const depositLink = `${appLink}/manage/deposit?currency=${MAIN_CURRENCY}#fiat`;

  return (
    <>
      <Header padding={"50 20 250"}>
        <div className={style.linkHolder}>
          <Link to={appLink} className={style.back}>
            Back To Funds
          </Link>
        </div>
      </Header>
      <main className={style.depositsLandingPage}>
        <WhitePaper className={style.noPadding}>
          <section className={style.section}>
            <h1 className={cn(style.headline, "nostyle")}>
              Deposit USD with any currency using our auto-convert feature
            </h1>
            <div className={style.topHolder}>
              <div className={style.topHolderLeft}>
                <p>
                  To deposit USDT in your BnkToTheFuture (BF) account using bank
                  transfer, please follow the steps below. You are able to
                  deposit any traditional currency supported by SWIFT. A full
                  list can be found
                  <a
                    href={swiftDoc}
                    className={style.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    here
                  </a>
                  . Once received the bank will auto-convert your funds to USD
                  at the exchange rate at the point of receipt.
                </p>
                <p>
                  Please note when sending any currency other than USD the bank
                  will charge a foreign exchange fee which will only be known to
                  us after the conversion has taken place. You will have to
                  assume all currency risk and any third party bank fees will be
                  deducted from your deposit.
                </p>
                <Link to={depositLink} className={cn(elements.btn, style.btn)}>
                  Deposit Now
                </Link>
              </div>
              <div className={style.topHolderRight}>
                <img src={depositImg} width="576" alt="Deposit Fiat" />
              </div>
            </div>
          </section>
          <section className={cn(style.section, style.sectionBordered)}>
            <h2 className={style.headline}>How it works?</h2>
            <div className={style.middleHolder}>
              <div>
                <h4>
                  <span>1</span> Select Your Currency
                </h4>
                <p>
                  Select the currency you would like to send us by bank
                  transfer. Deposit any traditional currency supported by SWIFT.
                  {/* tslint:disable-next-line:max-line-length */}A full list
                  can be found{" "}
                  <a
                    href={swiftDoc}
                    className={style.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    here
                  </a>
                  .
                </p>
              </div>
              <div>
                <h4>
                  <span>2</span> Make a Bank Transfer
                </h4>
                <p>
                  Make the transfer with your bank using the details we provide.
                  Add the reference number we give you and send an international
                  wire in any currency using the SWIFT details provided.
                </p>
              </div>
              <div>
                <h4>
                  <span>3</span> We’ll convert it to USDT.
                </h4>
                <p>
                  As soon as we receive your funds our banking partners will
                  automatically convert them to USD and we will credit the
                  equivalent USDT amount in your BF funds to invest.
                  Congratulations, you're now in crypto, welcome to the speed
                  and efficiency of USDT.
                </p>
              </div>
            </div>
            <Link
              to={depositLink}
              className={cn(elements.btn, style.btn, style.btnCentered)}
            >
              Deposit Now
            </Link>
          </section>
          <section className={cn(style.section, style.faq)}>
            <h2 className={style.headline}>FAQ</h2>
            <div className={style.questionsHolder}>
              <ExpansionPanel questions={questions} />
            </div>
            <a
              href={`${process.env.WORDPRESS_DOMAIN}/blog/`}
              target="_blank"
              rel="noopener noreferrer"
              className={cn(
                elements.btn,
                style.btn,
                style.btnCentered,
                style.mt50,
              )}
            >
              Still have a question? View our blog
            </a>
          </section>
          <section className={cn(style.section, style.footer)}>
            <h2 className={style.headline}>
              Don't waste time <span>Deposit the money now!</span>
            </h2>
            <Link
              to={depositLink}
              className={cn(elements.btn, style.btn, style.btnCentered)}
            >
              Deposit Now
            </Link>
          </section>
        </WhitePaper>
      </main>
    </>
  );
};

export default DepositsLandingPage;
